import React, { Component } from 'react';
import { Table, message, Popconfirm, Button } from 'antd';
import './style.less';
import send from '../../util/request';
import CpProductChoose from './CpProductChoose';
const { localStorage, location } = window;

class selectProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productList: [],
      productObj: {},
      visible: false,
      currentProductList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      provinceList: [],
      cityList: [],
      provinceId: '',
      cityId: null,
      svcData: [],//svc区域
      svcId: '',
      svcName: ''
    };

    const { taskNo, supplierName, supplierCode } = this.props.match.params;
    this.taskNo = taskNo;
    this.supplierName = supplierName;
    this.supplierCode = supplierCode;
  }
  columns = [
    {
      title: '商品名称',
      dataIndex: 'sale_name',
      key: 'sale_name',
      align: 'center',
      width: 180
    },
    {
      title: '商品编码',
      dataIndex: 'sku_no',
      key: 'sku_no',
      align: 'center',
      width: 120
    },
    {
      title: '等级',
      dataIndex: 'level',
      key: 'level',
      align: 'center',
    },
    {
      title: '产地',
      dataIndex: 'place',
      key: 'place',
      align: 'center',
    },
    {
      title: '单位',
      dataIndex: 'unit',
      key: 'unit',
      align: 'center',
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      width: 120
    },
    {
      title: '单位重量(KG)',
      dataIndex: 'weight',
      key: 'weight',
      align: 'center',
      width: 120
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      fixed: 'right',
      render: (text, record) => (
        <Popconfirm
          title="是否要移除?"
          onConfirm={() => this.handleDelete(record, 1)}
          okText="确定"
          cancelText="取消">
          <a style={{ color: '#D60505' }}>移除</a>
        </Popconfirm>
      ),
    },
  ]

  componentDidMount() {
    const info = location.href.split('/');
    let obj = {
      taskNo: info[info.length - 3],
      supplierName: info[info.length - 2],
      supplierCode: info[info.length - 1]
    };
    localStorage.setItem('taskData', JSON.stringify(obj));
    const account = localStorage.getItem('account');
    const companyId = localStorage.getItem('companyId');
    const companyName = localStorage.getItem('companyName');
    this.setState({
      account,
      companyId,
      companyName
    });
    this.requestAreaData();
    this.requestSvcName();

  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  requestSvcName = () => {
    send({
      url: '/ipp/common/svc',
      method: 'POST',
    }).then(res => {
      if (res.data && res.data.code === 0) {
        const { data = [] } = res.data;
        this.setState({
          svcData: data
        });
      }
    });
  }
  requestAreaData(pid = 0) {
    send({
      url: '/ipp/order-plan-task/area',
      method: 'GET',
      params: {
        pid
      }
    }).then((res) => {
      if (res.data && res.data.code === 0) {
        const { data = [] } = res.data;
        if (pid === 0) {
          this.setState({
            provinceList: data
          });
        } else {
          this.setState({
            cityList: data
          });
        }
      }
    });
  }
  handleDelete = (record, type) => {
    let { selectedRowKeys, productObj, productList } = this.state;
    let array = [];
    if (type === 1) {
      array = [record.good_id];
    } else {
      array = selectedRowKeys;
    }

    array.forEach(item => {
      delete productObj[item];
    });
    productList = Object.values(productObj);
    this.setState({
      productObj,
      productList,
      total: productList.length,
      selectedRowKeys: []
    }, () => {
      this.handleProductList();
    });
  }
  selectProduct = () => {
    this.setState({
      visible: true
    });
  }
  hideModal = () => {
    this.setState({ visible: false });
  }
  submitModal = (submitObj) => {
    let { productObj, productList } = this.state;
    productObj = Object.assign({}, productObj, submitObj);
    productList = Object.values(productObj);
    this.setState({
      productObj,
      productList,
      total: productList.length
    }, () => {
      this.handleProductList();
    });
    this.setState({ visible: false });
  }
  handleProductList = () => {
    const { currentPage, pageSize, productList } = this.state;
    let start = (currentPage - 1) * pageSize;
    let end = start + pageSize;
    let currentProductList = productList.slice(start, end);
    this.setState({
      currentProductList
    });
  }
  submit = () => {
    const { productList } = this.state;

    if (!productList.length) {
      message.info('请先选择商品');
      return;
    }

    const { companyId } = this.state;
    const productIds = productList.map(obj => obj.good_id);
    let data = {
      order_no: this.taskNo,
      order_goods_id: productIds.join(','),
      purchase_id: companyId,
    };
    send({
      url: '/ipp/order-plan-task/submit-create',
      method: 'POST',
      data
    }).then(res => {
      if (res.data && res.data.code === 0) {
        this.props.history.push('/basic/user/prePlanReport/detail');
      } else {
        message.error(res.data.msg);
      }
    });

  }
  cancle = () => {
    this.props.history.go(-1);
  }
  provinceChanged = (value) => {
    let p = this.state.provinceList.find(obj => obj.id === value);
    let provinceName = '';
    if (p) {
      provinceName = p.name;
    }
    this.setState({
      provinceId: value,
      provinceName,
      cityId: '',
      cityList: []
    });
    this.requestAreaData(value);
  }

  cityChanged = (value) => {
    let city = this.state.cityList.find(obj => obj.id === value);
    let cityName = '';
    if (city) {
      cityName = city.name;
    }
    this.setState({
      cityId: value,
      cityName
    });
  }
  svcChanged = (value) => {
    let svc = this.state.svcData.find(obj => obj.id === value);
    let svcName = '';
    if (svc) {
      svcName = svc.name;
    }
    this.setState({
      svcId: value,
      svcName
    });
  }
  render() {
    // const { companyId, companyName, visible, currentProductList, currentPage, pageSize, total, selectedRowKeys, isBatchAdd, provinceList, cityList, cityId,svcData = []} = this.state
    const { companyId, companyName, visible, currentProductList, currentPage, pageSize, total, selectedRowKeys} = this.state;
    const chooseCheck = {
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          isBatchAdd: selectedRowKeys.length > 0 ? true : false,
          addList: selectedRows,
          selectedRowKeys,
        });
      },
    };

    return (
      <div className="select-products">
        <div>
          <span className="title">计划提报商品清单</span>
          {/* <span className="company-name">{companyName}公司（公司代码：{companyId}）操作账号：{account}</span> */}
        </div>
        <div style={{ margin: '20px 0px' }}>
          <div style={{ marginTop: '10px' }}>
            <span>统采公司：{this.supplierName}</span>
          </div>
          <div style={{ marginTop: '10px' }}>
            <span>统采公司编码：{this.supplierCode}</span>
          </div>
          <div style={{ marginTop: '10px' }}>
            <span>采购公司：{companyName}</span>
          </div>
          <div style={{ marginTop: '10px' }}>
            <span>采购公司编码：{companyId}</span>
          </div>
          {/* <div style={{ marginTop: '10px' }}>
            <span>设置计划区域：</span>
            <Select style={{width: '120px'}} placeholder='省' onChange={this.provinceChanged}>
              {
                provinceList.map(obj => {
                  return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                })
              }
            </Select>
            <Select style={{width: '120px'}} placeholder='市' onChange={this.cityChanged} value={cityId}>
              {
                cityList.map(obj => {
                  return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                })
              }
            </Select>
          </div>
          <div style={{ marginTop: '10px' }}>
            <span>设置SVC区域：</span>
            <Select style={{width: '120px'}} placeholder='SVC' onChange={this.svcChanged}>
              {
              svcData.length>0?  svcData.map(obj => {
                  return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                }):null
              }
            </Select>
          </div> */}
          <div style={{ marginTop: '10px' }}>
            <Button type="primary" style={{ marginTop: '10px' }} onClick={this.selectProduct}>选择商品</Button>
          </div>
        </div>
        <div style={{ textAlign: 'right', margin: '0 20px 10px 0' }}>
          {/* <Button disabled={!isBatchAdd} type="primary" style={{ marginTop: '10px' }} onClick={this.handleDelete}>批量移除</Button> */}
          <Button disabled={!(selectedRowKeys || []).length} type="primary" style={{ marginTop: '10px' }} onClick={this.handleDelete}>批量移除</Button>
        </div>
        <div>
          <Table
            rowKey={record => record.good_id}
            columns={this.columns}
            dataSource={currentProductList}
            rowSelection={chooseCheck}
            scroll={{ x: 1000 }}
            pagination={{
              pageSize: pageSize,
              total: total,
              current: currentPage,
              onChange: (currentPage, pageSize) => {
                this.setState(
                  {
                    currentPage,
                    pageSize,
                  },
                  () => {
                    this.handleProductList();
                  }
                );
              },
            }}
          />
        </div>
        <div style={{ margin: '40px 0px', textAlign: 'center' }}>
          <Button type="primary" onClick={this.submit}>提交</Button>
          <Button style={{ marginLeft: '20px' }} onClick={this.cancle}>取消</Button>
        </div>
        {
          visible ? <CpProductChoose
            taskNo={this.taskNo}
            hideModal={this.hideModal}
            submitModal={this.submitModal}>
          </CpProductChoose> : null
        }
      </div>
    );
  }
}
export default selectProducts;